// @flow
import { connect } from 'react-redux';

import { toggleDrawMode } from 'actions/drawOverlay';
import { toggleMobileLocationSearch } from 'actions/appBar';
import { toggleHUD } from 'actions/hud';
import { dndOverlaySetDndState } from 'actions/dndOverlay';

import AppBar from './AppBar';

const mapStateToProps = ({
  browser,
  appBar: { mobileLocationSearchShown },
  drawOverlay: { appInDrawMode },
  hud: { open: hudOpen },
  auth: { authTokenData, subscriptions },
  flags: { hasSubscription },
}) => ({
  browser,
  appInDrawMode,
  hudOpen,
  mobileLocationSearchShown,
  authTokenData,
  subscriptions,
  hasSubscription,
});

const mapDispatchToProps = {
  toggleDrawMode,
  toggleMobileLocationSearch,
  toggleHUD,
  dndOverlaySetDndState,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppBar);



// WEBPACK FOOTER //
// ./components/AppBar/index.js